"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HARD_PULL_CREDIT_SCORE_EXPLANATION = exports.HardPullTrigger = exports.FIXABLE_EXPERIAN_PULL_ERROR_TYPES = exports.INELIGIBLE_EXPERIAN_PULL_ERROR_TYPES = exports.ExperianPullErrorType = exports.EXPERIAN_FROZEN = exports.HardPullResult = void 0;
var HardPullResult;
(function (HardPullResult) {
    /**
     * We didn't try to make a hard pull.
     */
    HardPullResult["notAttempted"] = "notAttempted";
    /**
     * We tried to make a hard pull, but one or more credit files were locked.
     */
    HardPullResult["frozenFiles"] = "frozenFiles";
    /**
     * We successfully made a hard pull.
     */
    HardPullResult["successful"] = "successful";
})(HardPullResult || (exports.HardPullResult = HardPullResult = {}));
/**
 * Error code returned by the notary scheduling endpoints when an applicant's Experian file is frozen
 * (`HardPullResult.frozenFiles`) and must be unfrozen before a session can be scheduled.
 */
exports.EXPERIAN_FROZEN = 'EXPERIAN_FROZEN';
/** @TranslateToPython */
var ExperianPullErrorType;
(function (ExperianPullErrorType) {
    ExperianPullErrorType["invalidFirstName"] = "INVALID_FIRST_NAME";
    /* Experian confusingly returns invalid surname and last name as separate errors */
    ExperianPullErrorType["invalidSurname"] = "INVALID_SURNAME";
    ExperianPullErrorType["invalidLastName"] = "INVALID_LAST_NAME";
    ExperianPullErrorType["generationCodeRequired"] = "GENERATION_CODE_REQUIRED";
    ExperianPullErrorType["consumerIsAMinor"] = "CONSUMER_IS_A_MINOR";
    ExperianPullErrorType["consumerReportedFraud"] = "CONSUMER_REPORTED_FRAUD";
    ExperianPullErrorType["invalidSsn"] = "INVALID_SSN";
})(ExperianPullErrorType || (exports.ExperianPullErrorType = ExperianPullErrorType = {}));
/** @TranslateToPython */
exports.INELIGIBLE_EXPERIAN_PULL_ERROR_TYPES = [ExperianPullErrorType.consumerReportedFraud, ExperianPullErrorType.invalidSsn, ExperianPullErrorType.consumerIsAMinor];
exports.FIXABLE_EXPERIAN_PULL_ERROR_TYPES = [
    ExperianPullErrorType.invalidFirstName,
    ExperianPullErrorType.invalidSurname,
    ExperianPullErrorType.invalidLastName,
    ExperianPullErrorType.generationCodeRequired,
];
// Hard-pull timing and consent variants selected by the backend.
var HardPullTrigger;
(function (HardPullTrigger) {
    HardPullTrigger["intentToProceedWithPurchase"] = "intentToProceedWithPurchase";
    HardPullTrigger["notarySessionScheduling"] = "notarySessionScheduling";
    HardPullTrigger["inPersonNotarySessionScheduling"] = "inPersonNotarySessionScheduling";
    HardPullTrigger["uccSpecial"] = "uccSpecial";
    HardPullTrigger["offerAcceptance"] = "offerAcceptance";
})(HardPullTrigger || (exports.HardPullTrigger = HardPullTrigger = {}));
exports.HARD_PULL_CREDIT_SCORE_EXPLANATION = 'Checking your offer does not affect your credit score. If you proceed, we may perform a hard credit pull when you accept your offer or when you choose to sign with our notary or schedule a signing appointment. A hard credit pull may affect your credit score.';
